export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "/graphql/", "authType": "JWT", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}, "noAuth": {"httpEndpoint": "/graphql/", "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:noAuth.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}